import { Component, Input, OnInit } from "@angular/core";
import { Tournament } from "../../../../../shared/models/tournament";
import { User } from "../../../../../shared/models/user";
import { TableType } from "../../../../../shared/enums/table-type";

@Component({
  selector: "app-view-tournament-mobile-info",
  templateUrl: "./view-tournament-mobile-info.component.html",
  styleUrls: ["./view-tournament-mobile-info.component.scss"],
})
export class ViewTournamentMobileInfoComponent implements OnInit {
  @Input() tournament: Tournament;
  @Input() user: User;

  enumTableType = TableType;
  constructor() {}

  ngOnInit(): void {}
}
